// "2026-06-08" → "Jun 8 – Jun 14"
export const weekRangeLabel = (mondayIso) => {
  if (!mondayIso) return "";
  const mon = new Date(mondayIso + "T00:00:00");
  const sun = new Date(mon);
  sun.setDate(mon.getDate() + 6);
  const f = (d) => d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  return `${f(mon)} – ${f(sun)}`;
};

// "2026-06-08" → "6/8"
export const shortDate = (iso) =>
  iso ? new Date(iso + "T00:00:00").toLocaleDateString(undefined, { month: "numeric", day: "numeric" }) : "";
